export default function ValentinesDayScreenshot(){
    return (
        <>
            <img src='screenshot-valentines-day.jpg' style={{maxWidth:'100%'}} />
            

        </>
    )
}